import { FC, useState } from 'react';

type ImpersonationBannerProps = {
  username: string;
};

export const ImpersonationBanner: FC<ImpersonationBannerProps> = ({ username }) => {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) {
    return null;
  }

  return (
    <div style={{ background: '#b7ff43' }}>
      <div className="slds-container--x-large slds-container--center rio-impersonation-banner">
        <span className="slds-text-heading--small">Logged In As "{username}"</span>
        <a href="/stop-impersonate">
          <span className="text-black text-bold slds-text-body--small slds-m-left--small">[Back to Account]</span>
        </a>
        <i
          className="fa fa-times rio-impersonation-icon"
          onClick={() => {
            setIsVisible(!isVisible);
          }}
        />
      </div>
    </div>
  );
};
